
import { css } from 'lit';
export default css`
.cta-featured__item {
  position: relative;
}
  .cta-featured__item {
  display: flex;
}
  .cta-featured__item {
  flex-direction: column;
}
  .cta-featured__item {
  align-items: center;
}
  @media (min-width: 640px) {
  .cta-featured__item {
    display: block;
  }
}
  @media (min-width: 1200px) {
  .cta-featured__item {
      height: 470px
  }
    }
  .cta-featured__image {
  width: 100%;
}
  @media (min-width: 640px) {
  .cta-featured__image {
    position: absolute;
  }
}
  @media (min-width: 640px) {
  .cta-featured__image {
    top: 50%;
  }
}
  @media (min-width: 640px) {
  .cta-featured__image {
    z-index: 10;
  }
}
  @media (min-width: 640px) {
  .cta-featured__image {
    height: 100%;
  }
}
  @media (min-width: 640px) {
  .cta-featured__image {
    width: auto;
  }
}
  @media (min-width: 640px) {
  .cta-featured__image {
      margin-top: -135px;
      height: 270px
  }
    }
  @media (min-width: 1200px) {
  .cta-featured__image {
    position: absolute;
  }
}
  @media (min-width: 1200px) {
  .cta-featured__image {
    top: 0px;
  }
}
  @media (min-width: 1200px) {
  .cta-featured__image {
    margin-top: 0px;
  }
}
  @media (min-width: 1200px) {
  .cta-featured__image {
      height: 470px
  }
    }
  .cta-featured__content {
  position: relative;
}
  .cta-featured__content {
  display: flex;
}
  .cta-featured__content {
  flex-shrink: 0;
}
  .cta-featured__content {
  flex-direction: column;
}
  .cta-featured__content {
  align-items: flex-start;
}
  .cta-featured__content {
  justify-content: center;
}
  .cta-featured__content {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
  .cta-featured__content {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
  @media (min-width: 640px) {
  .cta-featured__content {
    width: 70%;
  }
}
  @media (min-width: 640px) {
  .cta-featured__content {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
}
  @media (min-width: 640px) {
  .cta-featured__content {
    padding-left: 4rem;
    padding-right: 4rem;
  }
}
  @media (min-width: 640px) {
  .cta-featured__content {
      min-height: 470px
  }
    }
  @media (min-width: 1200px) {
  .cta-featured__content {
    z-index: 20;
  }
}
  @media (min-width: 1200px) {
  .cta-featured__content {
      width: 45%;
      height: 470px
  }
    }
  .cta-featured__content:after {
      content: "";
      position: absolute;
      z-index: 2;
      top: -40px;
      left: 50%;
      margin-left: -50px;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 50px 50px 50px;
    }
  @media (min-width: 640px) {
  .cta-featured__content:after {
        left: unset;
        top: 50%;
        margin-left: 0;
        margin-top: -50px
    }
      }
  .cta-featured__text {
  padding-top: 0.75rem;
}
  .cta-featured__text {
  font-family: Lato, sans-serif;
}
  .cta-featured__text {
  font-size: 1.125rem;
}
  .cta-featured__text {
  line-height: 1.5;
}
  @media (min-width: 1200px) {
  .cta-featured__text {
    font-size: 1.25rem;
  }
}
  .cta-featured__link {
  padding-top: 1.5rem;
}
  .cta-featured--gray-purple .cta-featured--odd .cta-featured__content {
  --tw-bg-opacity: 1;
  background-color: rgba(242, 242, 242, var(--tw-bg-opacity));
}
  .cta-featured--gray-purple .cta-featured--even .cta-featured__content {
  --tw-bg-opacity: 1;
  background-color: rgba(53, 25, 108, var(--tw-bg-opacity));
}
  .cta-featured--gray-purple .cta-featured--even .cta-featured__content {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
  .cta-featured--white-gray .cta-featured--odd .cta-featured__content {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}
  .cta-featured--white-gray .cta-featured--even .cta-featured__content {
  --tw-bg-opacity: 1;
  background-color: rgba(242, 242, 242, var(--tw-bg-opacity));
}
  @media (min-width: 640px) {
  .cta-featured .cta-featured--image-right .cta-featured__content {
    padding-right: 12rem;
  }
}
  @media (min-width: 1200px) {
  .cta-featured .cta-featured--image-right .cta-featured__content {
    padding-right: 4rem;
  }
}
  .cta-featured .cta-featured--image-right .cta-featured__content:after {
        border-color: transparent transparent #f2f2f2 transparent;
      }
  @media (min-width: 640px) {
  .cta-featured .cta-featured--image-right .cta-featured__content:after {
          border-width: 50px 0 50px 65px;
          border-color: transparent transparent transparent #f2f2f2;
          right: -65px
      }
        }
  @media (min-width: 640px) {
  .cta-featured .cta-featured--image-right .cta-featured__image {
    left: 70%;
  }
}
  @media (min-width: 640px) {
  .cta-featured .cta-featured--image-right .cta-featured__image {
        margin-left: -150px;
    }
      }
  @media (min-width: 1200px) {
  .cta-featured .cta-featured--image-right .cta-featured__image {
    left: 50%;
  }
}
  @media (min-width: 1200px) {
  .cta-featured .cta-featured--image-right .cta-featured__image {
    margin-left: 0px;
  }
}
  @media (min-width: 640px) {
  .cta-featured .cta-featured--image-left .cta-featured__content {
    margin-left: 30%;
  }
}
  @media (min-width: 640px) {
  .cta-featured .cta-featured--image-left .cta-featured__content {
    padding-left: 12rem;
  }
}
  @media (min-width: 1200px) {
  .cta-featured .cta-featured--image-left .cta-featured__content {
    margin-left: 55%;
  }
}
  @media (min-width: 1200px) {
  .cta-featured .cta-featured--image-left .cta-featured__content {
    padding-left: 4rem;
  }
}
  .cta-featured .cta-featured--image-left .cta-featured__content:after {
        border-color: transparent transparent #35196c transparent;
      }
  @media (min-width: 640px) {
  .cta-featured .cta-featured--image-left .cta-featured__content:after {
          border-width: 50px 65px 50px 0;
          border-color: transparent #35196c transparent transparent;
          left: -65px
      }
        }
  @media (min-width: 640px) {
  .cta-featured .cta-featured--image-left .cta-featured__image {
    right: 70%;
  }
}
  @media (min-width: 640px) {
  .cta-featured .cta-featured--image-left .cta-featured__image {
        margin-right: -150px;
    }
      }
  @media (min-width: 1200px) {
  .cta-featured .cta-featured--image-left .cta-featured__image {
    right: 50%;
  }
}
  @media (min-width: 1200px) {
  .cta-featured .cta-featured--image-left .cta-featured__image {
    margin-right: 0px;
  }
}
`;